import {
  Button, Card, CardContent, CardHeader, FormControl, Grid, Typography,
} from '@material-ui/core';
import { StyleRules, withStyles } from '@material-ui/core/styles';
import { EmailOutlined } from '@material-ui/icons';
import i18next from 'i18next';
import * as React from 'react';
import { Navigate } from 'react-router';
import ARHttp from '../services/ARHttp';

const pageStyles: StyleRules = {
  pageHeader: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.24)',
    fontSize: '24px',
    width: '90%',
    padding: '0px',
    paddingTop: '5px',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: '24px',
  },
  avatarIcon: {
    color: '#585858',
    fontSize: '34px',
    paddingTop: '4px',
    marginRight: '-12px',
  },
  headerText: {
    fontSize: '28px',
  },
  pageContent: {
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'column',
  },
  cardContent: {
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexDirection: 'column',
  },
  buttonForm: {
    display: 'inline-block',
    paddingTop: '32px',
    marginTop: '8px',
  },
  genericInput: {
    width: '250px',
  },
  text: {
    paddingTop: '16px',
    fontSize: '18px',
  },
};

class VerifyEmailScreen extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.resendEmail = this.resendEmail.bind(this);
    this.state = {
      serverError: false,
    };
  }

  public componentDidMount() {
    window.document.title = 'Email Sent | Elavon';
  }

  public render() {
    const { classes, location } = this.props;
    if (!(location.state && location.state.emailAddress)) {
      return <Navigate to={{ pathname: '/register' }} />;
    }

    const title = (
      <Typography variant="h5" className={classes.headerText}>
        {i18next.t('confirm_your_email_header')}
      </Typography>
    );

    const avatar = (
      <Typography variant="h5">
        <EmailOutlined className={classes.avatarIcon} />
      </Typography>
    );

    return (
      <Card className={classes.pageContent}>
        <CardHeader className={classes.pageHeader} title={title} avatar={avatar} />
        <CardContent className={classes.cardContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" align="center" className={classes.text}>
              {i18next.t('a_message_has_been_sent_subheading')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" align="center" className={classes.text}>
              <a href={`mailto:${this.props.location.state.emailAddress}`} style={{ color: '#2F7DBD' }}>
                {this.props.location.state.emailAddress}
              </a>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" align="center" className={classes.text}>
              {i18next.t('please_open_your_email_subheading')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl className={classes.buttonForm} fullWidth>
              <Button variant="text" className={classes.genericInput} onClick={this.resendEmail}>
                {i18next.t('resend_email_button')}
              </Button>
            </FormControl>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  private resendEmail() {
    const {
      emailAddress, name, jurisdictionCode, locale, offerCode, subJurisdictionCode,
    } = this.props.location.state;
    ARHttp({
      method: 'POST',
      url: '/sb/account/sendemail',
      body: {
        email: emailAddress,
        name,
        jurisdictionCode,
        locale,
        offerCode,
        subJurisdictionCode,
      },
    }).subscribe(
      (response: any) => {
        this.setState({
          serverError: false,
        });
      },
      () => {
        this.setState({
          serverError: true,
        });
      },
    );
  }
}

export default withStyles(pageStyles)(VerifyEmailScreen);
